import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import store from "../../../shared_component/utils/configureStore"
import Button from "../../components/Button.js"
import MiniLoader from "../MiniLoader"
import Notifications from "../Notifications"
import { Input } from "semantic-ui-react"
import { updateInfo, verifyRideshareInspection } from "../../actions/user"
import { elements } from "caradvise_shared_components"
import { withTranslation } from "react-i18next"
import { identifyEvent } from "../../../shared_component/utils/segmentAnalytics"

const { BaseModalDialog } = elements

// This component and its API call were written quickly to fulfill rideshare inspections for Uber.
// It's a one-off feature that is a bit too specific.
class GatherZipModal extends React.Component {
  state = {
    isSubmitting: false,
    zip: "",
    apiResult: null
  }

  componentDidMount() {
    const { user, cart } = this.props
    if ((user || {}).zip == null) return

    this.setState({ isSubmitting: true }, async () => {
      const result = await verifyRideshareInspection({ cartId: cart.id })
      this.setState({ isSubmitting: false, apiResult: result })
    })
  }

  submitZip = (payload) => {
    const { updateInfo, verifyRideshareInspection, cart, closeModal } = this.props

    this.setState({ isSubmitting: true }, async () => {
      const successZip = await updateInfo({ zip: this.state.zip, displayErrorNotification: true })
      let payload = { isSubmitting: false }

      if (successZip === true) {
        const result = await verifyRideshareInspection({ cartId: cart.id })
        payload.apiResult = result
        await identifyEvent({
          traits: {
            zip: this.state.zip
          }
        })
      }

      if (payload.apiResult && payload.apiResult.success) {
        this.setState(payload, () => closeModal())
      } else {
        this.setState(payload)
      }
    })
  }

  render() {
    const { isOpen, closeModal, t } = this.props
    const { isSubmitting, zip, apiResult } = this.state

    return (
      <BaseModalDialog
        headerTitle={apiResult ? "" : t("needZipTitle")}
        isOpen={isOpen}
        toggleModal={closeModal}
      >
        {apiResult && apiResult.failure && (
          <div className="gather-zip-modal-message">
            <div>{t("inspectionTypeDesc")}</div>
            <div>{t("statesRequireEnhancedDesc")}</div>
          </div>
        )}

        {!apiResult && (
          <React.Fragment>
            <div className="gather-zip-modal-message">{t("pleaseEnterZipCodeDesc")}</div>
            <div style={{ margin: "0 auto" }}>
              <Input
                value={zip}
                style={{ width: "150px" }}
                onChange={(e, { _, value }) => this.setState({ zip: value })}
                fluid
                placeholder={t("zipCodePlaceholder")}
              />
            </div>
            <Button
              disabled={isSubmitting || zip.length === 0}
              style={{ marginTop: "1.3em", height: "0.95em" }}
              colorStyle="orange"
              styleText={{ color: "white" }}
              text={isSubmitting ? <MiniLoader /> : t("continueText")}
              onClick={this.submitZip}
            />
          </React.Fragment>
        )}
      </BaseModalDialog>
    )
  }
}

GatherZipModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
}

export default connect(() => ({}), { updateInfo, verifyRideshareInspection })(
  withTranslation("gatherZipModal")(GatherZipModal)
)
